import * as types from './ActionTypes';

export const applyOrgFilter = (data) => dispatch => {
  dispatch({
    type: types.SET_ORG_FILTERED_DATA,
    payload: data
  });
};

export const applyPeopleFilter = (data) => dispatch => {
  dispatch({
    type: types.SET_PEOPLE_FILTERED_DATA,
    payload: data
  });
};

export const setSearchTerm = (data) => dispatch => {
  dispatch({
    type: types.SET_SEARCH_TERM,
    payload: data
  });
};
export const clearSearchTerm = () => dispatch => {
  dispatch({
    type: types.CLEAR_SEARCH_TERM
  });
};

export const applyLotFilter = (data) => dispatch => {
  dispatch({
    type: types.SET_LOTS_FILTERED_DATA,
    payload: data
  });
};

export const applySearch = (data, term) => dispatch => {
  if (data.length === 0) {
    if (term === '') {
      dispatch(applyPeopleFilter(null));
      dispatch(applyLotFilter(null));
      dispatch(applyOrgFilter(null));
    } else {
      dispatch(applyPeopleFilter([]));
      dispatch(applyLotFilter([]));
      dispatch(applyOrgFilter([]));
    }
  } else {
    dispatch(applyPeopleFilter(data));
    dispatch(applyLotFilter(data));
    dispatch(applyOrgFilter(data));
  }
};

export const clearAllFilters = () => dispatch => {
  dispatch(applyLotFilter(null));
  dispatch(applyPeopleFilter(null));
  dispatch(applyOrgFilter(null));
};



// WEBPACK FOOTER //
// ./src/actions/filter.action.js